import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Link from 'components/common/Link';

import Tooltip from 'components/common/Tooltip';

import { collapseMainNavigation } from 'redux/modules/routerParams';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  listItemRoot: {
    padding: 0,
    color: theme.palette.common.white,
    minHeight: 51,
  },
  listItemRootActive: {
    color: theme.palette.secondary['800'],
    backgroundColor: theme.palette.common.white,
  },
  listItemTextRoot: {
    padding: '0',
    marginRight: 10,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  listItemTextPrimary: {
    fontSize: pxToRem(14),
    fontWeight: 400,
    letterSpacing: pxToEm(0.7, 14),
    lineHeight: pxToEm(21, 14),
    color: 'inherit',
    padding: '0',
    marginRight: 10,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  tooltip: {
    maxWidth: '100%',
  },
  link: {
    maxWidth: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'hidden',
    padding: '16px 5px 16px 11px',
  },
});

const NavigationItem = ({
  title, href, icon, router, history, expanded, classes, actions,
}) => {
  const checkActiveRoute = () => {
    if (href === router.location.pathname) {
      return true;
    }
    if (href === '/charts'
        && router.location.pathname.indexOf('/charts') !== -1) {
      return true;
    }
    if (href === '/workflow/delivery/schedule'
        && router.location.pathname.indexOf('/schedule') !== -1) {
      return true;
    }
    if (href === '/inventory'
        && router.location.pathname.indexOf('/inventory') !== -1) {
      return true;
    }
    if (href === '/workflow'
        && router.location.pathname.indexOf('/workflow') !== -1
        && router.location.pathname.indexOf('/schedule') === -1) {
      return true;
    }
    if (href === '/reports'
        && router.location.pathname.indexOf('/reports') !== -1) {
      return true;
    }
    if (href === '/claims'
        && router.location.pathname.indexOf('/claims') !== -1) {
      return true;
    }
    return false;
  };

  return (
    <ListItem
      // button
      disableGutters
      classes={{
        root: classNames(classes.listItemRoot, {
          [classes.listItemRootActive]: checkActiveRoute(),
        }),
      }}
      // onClick={() => {
      //   if (href === router.location.pathname) {
      //     history.push(href);
      //   } else {
      //     window.open(href, '_blank', 'noopener=true');
      //   }
      // }}
      
    >
      <Tooltip
        className={classes.tooltip}
        content={title}
        placement="right"
        color="dark"
        disableGutters
        disabled={expanded}
      >
        <Link
          className={classes.link}
          href={href}
          onClick={() => {
            setTimeout(() => {
              actions.collapseMainNavigation();
            }, 100);
          }}
        >
          {icon}
          <div className={classes.listItemTextPrimary}>
            {title}
          </div>
        </Link>
{/*        <ListItemIcon>
          {icon}
        </ListItemIcon>*/}
      </Tooltip>
{/*      <ListItemText
        primary={title}
        classes={{
          root: classes.listItemTextRoot,
          primary: classes.listItemTextPrimary,
        }}
      />*/}
    </ListItem>
  );
};

NavigationItem.propTypes = {
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  expanded: PropTypes.bool.isRequired,
  router: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    listItemRoot: PropTypes.string.isRequired,
    listItemRootActive: PropTypes.string.isRequired,
    listItemTextRoot: PropTypes.string.isRequired,
    listItemTextPrimary: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = store => ({
  router: store.router,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    collapseMainNavigation,
  }, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(NavigationItem)),
);



// WEBPACK FOOTER //
// ./src/components/common/Layout/DefaultNavigation/DefaultNavigationItem.js